import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Section,
  Warning,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const CqcRegistrationCentre = () => (
  <Page
    title="CQC Registration Centre"
    intro="The Registration Centre answers a different question from the rest of the CQC Centre: do you need to be CQC-registered for the medical cover you provide, and how ready are you for the 6 December 2027 events-registration deadline?"
  >
    <Section title="Registration dashboard">
      <p>
        Open{' '}
        <DocLink url="/cqc-centre/registration" text="Registration Centre" />{' '}
        from the card on the CQC Centre dashboard. It summarises your
        regulated activities and their registration status, event exposure
        assessment outcomes, upcoming events still missing an assessment, and
        - most importantly - events booked past the 6 December 2027 deadline
        whose exposure is unresolved.
      </p>
      <Info title="Who can do this?">
        Registration Centre pages require the Governance team, except event
        exposure assessments, which can also be completed by the Event
        Planning team (whoever builds the event management plan). Site
        administrators always have access. The CQC Centre is a tier 2
        feature.
      </Info>
    </Section>

    <Section title="Regulated activities">
      <p>
        Track each regulated activity you provide from{' '}
        <DocLink
          url="/cqc-centre/registration/activities"
          text="Regulated Activities"
        />
        : the activity type (Treatment of disease, disorder or injury, or
        Transport services, triage and medical advice), the location or
        premises, and its registration status - Not Registered, Preparing
        Application, Applied, Registered, Exempt, or Not Applicable - plus
        CQC provider/location IDs and key dates.
      </p>
    </Section>

    <Section title="Event exposure assessments">
      <Bullets>
        <Bullet>
          Each event can carry a CQC exposure assessment, completed from the
          event's page by whoever is planning it. The outcome is indicative
          only: <strong>Likely Exempt</strong>,{' '}
          <strong>Likely Requires Registration</strong>, or{' '}
          <strong>Uncertain</strong>.
        </Bullet>
        <Bullet>
          Review all assessments in one place from{' '}
          <DocLink
            url="/cqc-centre/registration/assessments"
            text="Event CQC Exposure Assessments"
          />
          , filterable by outcome, with each row linking back to its event.
        </Bullet>
      </Bullets>
      <Warning title="Indicative outcomes only">
        "Likely exempt" and "likely requires registration" are working
        assessments to help you plan - they are not legal advice or a CQC
        determination.
      </Warning>
    </Section>

    <Section title="Statement of Purpose">
      <p>
        Build and maintain your CQC Statement of Purpose from{' '}
        <DocLink
          url="/cqc-centre/registration/statement-of-purpose"
          text="Statement of Purpose"
        />
        , including your regulated activities and locations, then export it as
        a PDF when you need to submit or share it.
      </p>
    </Section>

    <Section title="Deadline alerts">
      <p>
        From{' '}
        <DocLink
          url="/cqc-centre/registration/settings"
          text="Registration Centre Settings"
        />{' '}
        turn deadline alerts on or off. When enabled, your Governance team is
        notified as the 6 December 2027 registration deadline approaches, and
        the settings page keeps a history of the alerts already sent.
      </p>
    </Section>
  </Page>
)

export default CqcRegistrationCentre
